import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=481a6d4f&scoped=true"
import script from "./Booking.vue?vue&type=script&lang=js"
export * from "./Booking.vue?vue&type=script&lang=js"
import style0 from "./Booking.vue?vue&type=style&index=0&id=481a6d4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a6d4f",
  null
  
)

export default component.exports